import gql from 'graphql-tag';

export const RoleFragment = gql`
  fragment RoleFragment on Role {
    id
    name
    description
  }
`;
